import { Alert, Stack, Typography } from "@mui/material";
import HorizontalFill from "../../../components/HorizontalFill.tsx";
import { intercomArticleIds } from "../../../utilities/intercomArticles.ts";
import ReadMoreArticleLink from "./ReadMoreArticleLink.tsx";

interface Props {
  selectedCount: number;
  totalCount?: number;
  limit: number;
}

const SelectedItemsCount = ({ selectedCount, totalCount, limit }: Props) => {
  const limitReached = selectedCount >= limit;
  if ((totalCount ?? 0) <= limit && !limitReached) {
    return null;
  }
  return (
    <>
      <Stack direction="row" sx={{ alignItems: "center" }}>
        <Typography color="textSecondary" sx={{ px: 1 }}>
          Selected
        </Typography>
        <HorizontalFill />
        <Typography color="textSecondary" sx={{ px: 1 }}>
          {`${selectedCount}/${limit}`}
        </Typography>
      </Stack>
      {limitReached && (
        <Alert severity="warning">
          <Typography>
            The selection limit of {limit} values has been reached. Deselect a value before selecting another.{" "}
            <ReadMoreArticleLink articleId={intercomArticleIds.CONDITION_SETUP_GUIDE}>Read more.</ReadMoreArticleLink>
          </Typography>
        </Alert>
      )}
    </>
  );
};

export default SelectedItemsCount;
